import React from 'react';

interface FlagIconProps {
  className?: string;
}

export const SpainFlag: React.FC<FlagIconProps> = ({ className = 'w-5 h-5' }) => (
  <svg
    viewBox="0 0 640 480"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="640" height="480" fill="#AA151B" />
    <rect y="160" width="640" height="160" fill="#F1BF00" />
  </svg>
);

export const BrazilFlag: React.FC<FlagIconProps> = ({ className = 'w-5 h-5' }) => (
  <svg
    viewBox="0 0 750 500"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="750" height="500" fill="#009739" />
    <path
      d="M375 250 L 500 125 L 500 375 Z"
      fill="#FEDD00"
    />
    <circle cx="375" cy="250" r="100" fill="#012169" />
    <path
      d="M375 200 L 400 250 L 375 300 L 350 250 Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const USAFlag: React.FC<FlagIconProps> = ({ className = 'w-5 h-5' }) => (
  <svg
    viewBox="0 0 60 30"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Fondo rojo con rayas blancas */}
    <rect width="60" height="30" fill="#B22234" />
    <rect y="2.3" width="60" height="2.3" fill="#FFF" />
    <rect y="6.9" width="60" height="2.3" fill="#FFF" />
    <rect y="11.5" width="60" height="2.3" fill="#FFF" />
    <rect y="16.1" width="60" height="2.3" fill="#FFF" />
    <rect y="20.7" width="60" height="2.3" fill="#FFF" />
    <rect y="25.3" width="60" height="2.3" fill="#FFF" />
    {/* Cuadro azul con estrellas simplificadas */}
    <rect width="24" height="16.1" fill="#3C3B6E" />
    <circle cx="4" cy="3" r="0.8" fill="#FFF" />
    <circle cx="8" cy="3" r="0.8" fill="#FFF" />
    <circle cx="12" cy="3" r="0.8" fill="#FFF" />
    <circle cx="16" cy="3" r="0.8" fill="#FFF" />
    <circle cx="20" cy="3" r="0.8" fill="#FFF" />
    <circle cx="6" cy="5.5" r="0.8" fill="#FFF" />
    <circle cx="10" cy="5.5" r="0.8" fill="#FFF" />
    <circle cx="14" cy="5.5" r="0.8" fill="#FFF" />
    <circle cx="18" cy="5.5" r="0.8" fill="#FFF" />
    <circle cx="4" cy="8" r="0.8" fill="#FFF" />
    <circle cx="8" cy="8" r="0.8" fill="#FFF" />
    <circle cx="12" cy="8" r="0.8" fill="#FFF" />
    <circle cx="16" cy="8" r="0.8" fill="#FFF" />
    <circle cx="20" cy="8" r="0.8" fill="#FFF" />
  </svg>
);
